import { useState } from "react"
import { useTracker } from "@modules/analytics"
import { makeClosableWindow } from "./window"
import { useOnPremisesGitConnectionByIdQuery } from "@modules/organization/queries.generated"
const INTERVAL_AFTER_POPPING = 8000
function noop() {
  return
}
const GITHUB_APP_URL = `https://github.com/apps/${process.env.GATSBY_GITHUB_APP_NAME}/installations/new`
const makeUrl = ({ instanceUrl, appSlug } = {}) =>
  instanceUrl && appSlug // in case we have bad data we don't want to open this
    ? `${instanceUrl}/github-apps/${appSlug}/installations/new`
    : ``
export default function useInstallationWindow(onCloseWindow, options = {}) {
  const defaultInterval = options?.defaultInterval || 60000
  const { trackButtonClicked } = useTracker()
  const [pollInterval, setPollInterval] = useState(defaultInterval)
  const isSelfHosted = !!options.vcsConfigId
  const { data, loading } = useOnPremisesGitConnectionByIdQuery({
    skip: !isSelfHosted,
    variables: {
      id: options.vcsConfigId,
    },
  })

  const resetInterval = () => {
    setPollInterval(defaultInterval)
  }

  if (loading && isSelfHosted) {
    return {
      pollInterval,
      resetInterval,
      popInstallationWindow: noop,
    }
  }
  const [openGithubInstallWindow] = makeClosableWindow(
    isSelfHosted && data?.publicVcsConfigById
      ? makeUrl(data?.publicVcsConfigById)
      : GITHUB_APP_URL,
    onCloseWindow,
    // An alternate path is used to trigger onCloseWindow
    // because the Close component doesn't have access to the enterprise server URL
    { alternatePath: isSelfHosted && GITHUB_APP_URL }
  )

  const popInstallationWindow = (trackName, trackOpts) => {
    trackButtonClicked(trackName, trackOpts)

    setPollInterval(INTERVAL_AFTER_POPPING)

    openGithubInstallWindow()
  }

  return {
    pollInterval,
    resetInterval,
    popInstallationWindow,
  }
}
